import { ROUTES_PUBLIC_LIVE_ADMIN } from '@/constants/routes';
import { initSocketIo, loadGoogleMaps } from './live';

export default {
    path: '/public/admin',
    name: 'public-admin',
    component: () => import(/* webpackChunkName: 'public-live-admin' */ '@/views/public/Live'),
    meta: {
        requiresAuth: true
    },
    children: [
        {
            path: '/public/admin/live/all',
            name: ROUTES_PUBLIC_LIVE_ADMIN,
            beforeEnter: beforeEnterLiveAdmin,
            component: () => import(/* webpackChunkName: 'public-live-admin' */ '@/components/public/admin/Admin')
        }
    ]
};

function beforeEnterLiveAdmin(to, from, next) {
    loadGoogleMaps();
    initSocketIo();
    next();
}
